import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { post_Schedule } from '../../services/Schedule';
import useAuth from '../../hook/useAuth';
import CustomFormatDatePicker from '../../components/CustomFormatDatePicker';
import useGroup from '../../hook/useGroup';
import Cookies from 'js-cookie';

const AddSchedule = () => {
     const token = Cookies.get("token-my-cdir");
    const { auth }: any = useAuth();
    const { selectedGroupId }: any = useGroup();
    const navigate = useNavigate();
    const [userData, setUserData] = useState<any>({
        groupId: 0,
        activityName: "",
        dayOfWeeK: 0,
        date: "",
        startTime: "",
        endTime: "",
        location: "",
        language: "",
        description: ""
    });
    const [isProcessing, setIsProcessing] = useState<boolean>(false);

    const closeModal = () => navigate(-1);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!isProcessing) {
            setIsProcessing(true);

            const dayOfWeek = new Date(userData.date).getDay();

            post_Schedule({
                ...userData,
                groupId: selectedGroupId,
                dayOfWeeK: dayOfWeek
            }, auth?.id, token!.toString())
                .then(() => {
                    setIsProcessing(false);
                    navigate(-1);
                })
                .catch(error => {
                    setIsProcessing(false);
                    console.error(error);
                });
        }
    }

    return (
        <div className="w-full">
            <div className="my-2">
                <div className="py-8 px-6 relative bg-white">
                    <h2 className="text-xl text-secondary font-bold">Add Schedule</h2>
                    <form onSubmit={handleSubmit} className="mt-8 grid xm:grid-cols-2 gap-6 text-secondary">
                        <div>
                            <label className="font-semibold text-sm">Activity Name</label>
                            <input type='text' placeholder='Enter Activity Name'
                                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                                value={userData?.activityName}
                                onChange={(e) => setUserData({ ...userData, activityName: e.target.value })}
                                required
                            />
                        </div>

                        <div>
                            <label className="font-semibold text-sm">
                                Date
                            </label>

                            <CustomFormatDatePicker
                                value={userData.date}
                                onChange={(val) =>
                                    setUserData((prev: any) => ({
                                        ...prev,
                                        date: val,
                                    }))
                                }
                                required={true}
                            />
                        </div>

                        <div>
                            <label className="font-semibold text-sm">Start Time</label>
                            <input type='time'
                                className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                value={userData.startTime}
                                onChange={(e) => setUserData({ ...userData, startTime: e.target.value })}
                                required
                            />
                        </div>

                        <div>
                            <label className="font-semibold text-sm">End Time</label>
                            <input type='time'
                                className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                value={userData.endTime}
                                onChange={(e) => setUserData({ ...userData, endTime: e.target.value })}
                                required
                            />
                        </div>

                        <div>
                            <label className="font-semibold text-sm">
                                Language <span className="text-gray-400">(Optional)</span>
                            </label>
                            <input
                                type="text"
                                placeholder="Enter Language"
                                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                                value={userData.language}
                                onChange={(e) => setUserData({ ...userData, language: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="font-semibold text-sm">Location</label>
                            <input type='text'
                                className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                value={userData.location}
                                onChange={(e) => setUserData({ ...userData, location: e.target.value })}
                                required
                            />
                        </div>

                        <div>
                            <label className="font-semibold text-sm">Description</label>
                            <textarea placeholder='Description'
                                className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                value={userData.description}
                                onChange={(e) => setUserData({ ...userData, description: e.target.value })}
                            />
                        </div>

                        <div />

                        <div className="flex max-xm:flex-col gap-4 !mt-4">
                            <button
                                type="button"
                                className="px-6 py-2 min-w-[150px] rounded text-black text-sm font-semibold border-none outline-none bg-gray-200 hover:bg-gray-300 active:bg-gray-200"
                                onClick={closeModal}
                            >
                                Cancel
                            </button>

                            <button
                                type="submit"
                                className="px-6 py-2 min-w-[150px] rounded text-white text-sm font-semibold border-none outline-none bg-secondary hover:bg-custom-blue"
                            >
                                {isProcessing ?
                                    <>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18px" fill="#fff" className="mr-2 inline animate-spin"
                                            viewBox="0 0 26.349 26.35">
                                            <circle cx="13.792" cy="3.082" r="3.082" data-original="#000000" />
                                            <circle cx="13.792" cy="24.501" r="1.849" data-original="#000000" />
                                            <circle cx="6.219" cy="6.218" r="2.774" data-original="#000000" />
                                            <circle cx="21.365" cy="21.363" r="1.541" data-original="#000000" />
                                            <circle cx="3.082" cy="13.792" r="2.465" data-original="#000000" />
                                            <circle cx="24.501" cy="13.791" r="1.232" data-original="#000000" />
                                            <path
                                                d="M4.694 19.84a2.155 2.155 0 0 0 0 3.05 2.155 2.155 0 0 0 3.05 0 2.155 2.155 0 0 0 0-3.05 2.146 2.146 0 0 0-3.05 0z"
                                                data-original="#000000" />
                                            <circle cx="21.364" cy="6.218" r=".924" data-original="#000000" />
                                        </svg>
                                        Processing...
                                    </>
                                    :
                                    "Save"
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddSchedule